// extracted by mini-css-extract-plugin
module.exports = {"navbarHeight":"60px","logo":"styles_logo__ICFmj"};